export default {
	routes: {
		public: [
			{ path: "/login", name: "Login", exact: true },
			{ path: "/forgot-password", name: "ForgotPassword", exact: true },
			{
				name: "ResetPassword",
				path: "/reset-password/:token",
				exact: true,
			},
		],
		private: [
			{
				path: "/banner-management",
				name: "Banner Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/banner-management/add",
				name: "Add Banner",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/banner-management/:id",
				name: "Edit Banner",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/business-unit-management",
				name: "Business Unit Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/business-unit-management/add",
				name: "Add Business Unit",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/business-unit-management/edit/:id",
				name: "Edit Business Unit",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/business-unit-management/:id",
				name: "Business Unit Detail",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/service-management",
				name: "Service Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/service-management/add",
				name: "Add Service",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/service-management/:id",
				name: "Edit Service",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/technology-management",
				name: "Technology Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/technology-management/add",
				name: "Add Technology ",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/technology-management/:id",
				name: "Edit Technology ",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/contact-message-management",
				name: "Contact Message Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/csr-management",
				name: "CSR Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/csr-management/add",
				name: "Add CSR",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/csr-management/edit/:id",
				name: "Edit CSR",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/csr-management/:id",
				name: "CSR Detail",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/csr-management/:id/sub-csr/add",
				name: "Add SubCSR",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/csr-management/:id/sub-csr/:subId",
				name: "Edit SubCSR",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/brand-management",
				name: "Brand Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/brand-management/add",
				name: "Add Brand ",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/brand-management/:id",
				name: "Edit Brand ",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/motto-management",
				name: "Motto Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/feature-management",
				name: "Feature Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/career-management",
				name: "Career Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/career-management/add",
				name: "Add Career",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/career-management/:id",
				name: "Edit Career",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/journies",
				name: "Journey Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/journies/add",
				name: "Add Journey",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/journies/:id",
				name: "Journey Detail",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/journies/edit/:id",
				name: "Edit Journey",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/branches",
				name: "Branch Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/branches/add",
				name: "Add Branch",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/about-us-management/branches/:id",
				name: "Edit Branch",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/master-data-management",
				name: "Master Data Management",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/admin-management",
				name: "Admin Listing",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/admin/my-account",
				name: "My Account",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/admin/change-password",
				name: "Change Password",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				path: "/admin/master-data",
				name: "Master Data",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Edit Profile",
				path: "/account-management/edit/:id",
				exact: true,
				config: { policies: [["*"], ["*"]] },
			},
			{
				name: "Content Management",
				path: "/content-management",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Faqs Management",
				path: "/content-management/faqs",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Terms Management",
				path: "/content-management/terms",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Privacy Policy Management",
				path: "/content-management/privacy-policy",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Create Faq Detail",
				path: "/content-management/faqs/create",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Edit Faq Detail",
				path: "/content-management/faqs/edit/:id",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Role Management",
				path: "/admin/role-management",
				exact: true,
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Push Notification Details",
				exact: true,
				path: "/admin/push-notifications/edit/:id",
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
			{
				name: "Master Audit Trail",
				path: "/admin/master-audit-trail",
				config: {
					config: { policies: [["*"], ["*"]] },
				},
			},
		],
	},
};
